import { Element } from "@siteimprove/alfa-dom";
import { PseudoClassSelector } from "./pseudo-class.js";
const { hasName, isElement } = Element;
/**
 * {@link https://drafts.csswg.org/selectors/#first-of-type-pseudo}
 */
export class FirstOfType extends PseudoClassSelector {
    static of() {
        return new FirstOfType();
    }
    constructor() {
        super("first-of-type");
    }
    *[Symbol.iterator]() {
        yield this;
    }
    matches(element) {
        return element
            .inclusiveSiblings()
            .filter(isElement)
            .filter(hasName(element.name))
            .first()
            .includes(element);
    }
    toJSON() {
        return super.toJSON();
    }
}
(function (FirstOfType) {
    FirstOfType.parse = PseudoClassSelector.parseNonFunctional("first-of-type", FirstOfType.of);
})(FirstOfType || (FirstOfType = {}));
//# sourceMappingURL=first-of-type.js.map